module.exports = __webpack_public_path__ + "img/association01.af256ab0.png";